import validator from "validator";

export function validateEmailMobile(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="" ) {
        msg="Enter Email or Mobile number";
        reference.current.focus();
        event.preventDefault();
    } else if (stateobject.length<9 
            || !(validator.isEmail(stateobject.trim()) 
                || (validator.isInt(stateobject.trim()) && stateobject.length>=10 && stateobject.length<=15
                    && stateobject.trim().indexOf('-')===-1 && stateobject.trim().indexOf('+')===-1 )) ) {
        msg="Enter valid Email or Mobile number";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validatePin(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="" ) {
        msg="Enter pin";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isInt(stateobject.trim()) || stateobject.length<6
        || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
        msg="Enter valid pin.";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validatePassword(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="" ) {
        msg="Enter password";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isStrongPassword(stateobject.trim()) ) {
        msg="Enter valid password";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateName(event, firstreference, firststateobject, lastreference, laststateobject){
    var msg = "";
    if(firststateobject.trim()==="") {
      msg="Enter first name";
      firstreference.current.focus();
      event.preventDefault();
    } else if(!validator.isAlpha(firststateobject.trim()) ) {
      msg="Enter valid first name";
      firstreference.current.focus();
      event.preventDefault();
    } else if(laststateobject.trim()==="") {
        msg="Enter last name";
        lastreference.current.focus();
        event.preventDefault();
    } else if(!validator.isAlpha(laststateobject.trim()) ) {
        msg="Enter valid last name";
        lastreference.current.focus();
        event.preventDefault();
    }  
    return msg;
}

export function validateEmail(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="") {
      msg="Enter email address";
      reference.current.focus();
      event.preventDefault();
    } else if (stateobject.trim().length<9 || !validator.isEmail(stateobject.trim()) ) {
      msg="Enter valid email address";
      reference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateMobile(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="" ) {
        msg="Enter mobile number";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isInt(stateobject.trim()) || stateobject.trim().length<10 
            || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
        msg="Enter valid mobile number";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateConfirmPassword(event, reference, stateobject, confirmreference, confirmstateobject){
    var msg = "";
    if(stateobject===null || stateobject.trim()==="" ) {
        msg="Enter password";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isStrongPassword(stateobject.trim()) ) {
        msg="Enter valid password. min: 8, max:20, required: 1 char, 1 digit, 1 cap, 1 special char";
        reference.current.focus();
        event.preventDefault();
    } else if(confirmstateobject===null || confirmstateobject.trim()==="") {
        msg="Enter confirm password";
        confirmreference.current.focus();
        event.preventDefault();
    } else if(confirmstateobject.trim()!==stateobject.trim()) {
        msg="New password and confirm password does not match";
        confirmreference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateConfirmPin(event, reference, stateobject, confirmreference, confirmstateobject){
    var msg = "";
    if(stateobject===null || stateobject.trim()==="" ) {
        msg="Enter pin";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isInt(stateobject.trim()) || stateobject.length<6
        || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
        msg="Enter valid pin. min: 6 digit, max: 15 digit";
        reference.current.focus();
        event.preventDefault();
    }
    else if(confirmstateobject===null || confirmstateobject.trim()==="") {
        msg="Enter confirm pin";
        confirmreference.current.focus();
        event.preventDefault();
    } else if(confirmstateobject.trim()!==stateobject.trim()) {
        msg="New pin and confirm pin does not match";
        confirmreference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateOTP(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()===""  ) {
        msg="Enter otp";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isInt(stateobject.trim()) || stateobject.length<5
        || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
        msg="Enter valid otp";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateTermsCheckBox(event,reference,isChecked){
    var msg = "";
    if(!isChecked) {
        reference.current.focus();
        return "Please accept terms & condition";
    }
    event.preventDefault();
    return msg;
}
